import React from 'react';
import ExoAvatar from '../../ExoAvatar';
import moment from 'moment';
import Typography from '@mui/material/Typography';
import { renderHours } from '../../../../scenes/time-tracking/worktime';
import { Box, IconButton, useTheme } from '@mui/material';
import { tokens } from '../../../../global/theme/tokens';
import { SettingsPopover } from '../../project/SettingsPopover';
import DeleteIcon from '@mui/icons-material/Delete';
import { useTranslation } from 'react-i18next';
import { useMethodColor } from '../time-functions/useMethodColors';
import RenderHTML from '../../../preview/RenderHTML';

export const TimeElement = ({ time }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);
  const { t } = useTranslation();

  // color
  var colorToUse = useMethodColor(time.method);
  const { timeStart, timeEnd, method } = time;

  const itemIsDeleted = method === 'delete';
  const itemIsAdded = method === 'add';
  const itemIsUpdated = method === 'update';

  const client = time.project?.client ?? {};
  const name = time.project
    ? time.project.clientType === 'company'
      ? client?.name ?? t('Internal')
      : `${client?.firstName ?? ''} ${client?.lastName ?? ''}`.trim()
    : t('Internal');

  const timeDiff = moment(timeEnd).diff(moment(timeStart), 'm');

  const timeLabel =
    time.comment || (time.workPackage && time.workPackage.title);

  const settings = [
    {
      Icon: DeleteIcon,
      label: t('Delete'),
      onClick: () => {},
      color: 'error',
    },
  ];

  const project = time.project || { client: {}, name: t('DELETED') };

  return (
    <Box
      className="flex flex-col w-full items-center justify-between rounded-md px-2 py-1 border-[1px]"
      sx={{
        bgcolor: colorToUse.primary,
        borderColor: colorToUse.secondary,
        opacity: itemIsDeleted ? 0.3 : 1,
      }}
    >
      <Box className="flex items-center gap-2 w-full">
        {time.workPackage?.icon?.temporaryUrl ? (
          <img
            src={time.workPackage.icon.temporaryUrl}
            className="h-[30px] w-[30px] rounded-[5px] object-cover"
            alt="Work Package Icon"
          />
        ) : time.project?.image?.temporaryUrl ? (
          <img
            src={time.project.image.temporaryUrl}
            className="h-[30px] w-[30px] rounded-[5px] object-cover"
            alt="Project Image"
          />
        ) : (
          <ExoAvatar
            size="30px"
            picture={client.logo?.temporaryUrl}
            name={name}
            type={time.project?.clientType || 'company'}
          />
        )}
        <Box className="flex flex-col w-full">
          <Typography fontSize="14px" fontWeight="500">
            {project.name}
          </Typography>
          <Typography fontSize="12px" className="opacity-50">
            {timeLabel ? <RenderHTML HTML={timeLabel} /> : ''}
          </Typography>
        </Box>
      </Box>
      <Box className="flex items-end justify-between w-full">
        <Typography
          className="monospace opacity-50"
          fontWeight="600"
          fontSize="11px"
        >
          {`${moment(timeStart).format('HH:mm')} - ${moment(timeEnd).format(
            'HH:mm'
          )}`}
        </Typography>
        <Typography
          fontWeight="600"
          fontSize="11px"
          className="monospace"
        >{`${renderHours(timeDiff)} h`}</Typography>

        {false && <SettingsPopover settings={settings} />}
      </Box>
    </Box>
  );
};
